import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../images/mobile_page_map.webp'


const _hoisted_1 = { class: "tetrapak-page-map" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title d-none d-md-block" }, " 本キャンペーンの対象は、関西エリア83店舗のイオンです。 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "content1 d-block d-md-none" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "img-fluid"
  })
], -1)

import { onMounted, ref } from 'vue';
import { loadScript } from 'vue-plugin-load-script';
import { GOOGLE_MAP_API_URL } from '@/constants';
import { locations } from '../map';

interface Location {
  locationName: string;
  postalCode: string;
  address: string;
  tel: string;
  lat: number;
  lng: number;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const root = ref();
let map: google.maps.Map;
const markerMap: {[key: string]: { infoWindow: google.maps.InfoWindow, marker: google.maps.Marker }} = {};

const loadMap = async () => {
  await loadScript(GOOGLE_MAP_API_URL);
  const mapInstance = new google.maps.Map(root.value, {
    zoom: 10,
  });

  mapInstance.addListener('click', () => {
    Object.values(markerMap).forEach(({ infoWindow }) => infoWindow.close());
  });

  return mapInstance;
};

function setCenter(location: google.maps.LatLng) {
  map.panTo(location);
}


function createInfoWindow(location: Location) {
  const contentString = `
    <div class="tetrapak-map-infowindow">
      <div class="title">
        ${location.locationName}
      </div>
      <div class="address">
        ${location.address}
      </div>
      <div class="divider"></div>
      <div class="tel">
        <span class="label">TEL:</span>${location.tel}
      </div>
    </div>
  `;
  return new google.maps.InfoWindow({
    content: contentString,
    pixelOffset: new google.maps.Size(0, -5)
  });
}

async function setMarker(location: Location) {
  const position = new google.maps.LatLng(location.lat, location.lng);
  const marker = new google.maps.Marker({
    position,
    map
  });

  const infoWindow = createInfoWindow(location);
  markerMap[location.locationName] = {
    infoWindow,
    marker
  };
  marker.addListener('click', () => {
    Object.values(markerMap).forEach(({ infoWindow }) => infoWindow.close());
    infoWindow.open({
      anchor: marker,
      map,
      shouldFocus: false
    });
  });

  return marker;
}

onMounted(async () => {
  map = await loadMap();
  // 设置地图中心点为第一个位置
  const firstLocation = locations[0];
  setCenter(new google.maps.LatLng(firstLocation.lat, firstLocation.lng));

  // 为所有位置添加标记
  locations.forEach(location => {
    setMarker(location);
  });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", {
      ref_key: "root",
      ref: root,
      class: "map-container"
    }, null, 512)
  ]))
}
}

})